let auth0UserId: string | null = null;

export const setAuth0UserId = (userId: string | null) => {
  auth0UserId = userId;
};

export const getAuth0UserId = (): string => {
  return auth0UserId || '';
};
